import { useMutation } from "@tanstack/react-query";
import { changePassword } from "../../api/user";

interface ChangePasswordParams {
  currentPassword: string;
  newPassword: string;
}

export function useChangePassword() {
  return useMutation({
    mutationFn: ({ currentPassword, newPassword }: ChangePasswordParams) =>
      changePassword(currentPassword, newPassword),
  });
}
